/**
 * Strips all non digit characters (0-9) from the given string.
 * @param str The input string that will be stripped.
 * @returns A new string without any non digit character.
 */
export default function removeAllNonDigitChar(str: string) {
  return str.replaceAll(/\D+/g, '')
}
